
export const naruhoneStyles = {
    h2Text: `antialiased font-medium tracking-tight text-slate-200 selection:bg-primary selection:text-white`,
    h1Text: 'antialiased font-bold tracking-tight text-slate-200 selection:bg-primary selection:text-white',
    pText: 'text-slate-400 leading-normal antialiased selection:bg-primary selection:text-white'
}   
